<button
  *ngIf="comment.voted !== null"
  type="button"
  class="btn btn-sm"
  [ngClass]="{
    disabled: isSubmitting,
    'btn-outline-primary': !comment.voted.upVote,
    'btn-primary': comment.voted.upVote
  }"
  (click)="toggleUpvote()"
  placement="right"
  ngbTooltip="Vote comment as meaningful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-up"></i>
    <span>{{ comment.upVoteCount }}</span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>

<button
  *ngIf="comment.voted === null"
  type="button"
  class="btn btn-sm btn-outline-primary"
  [ngClass]="{ disabled: isSubmitting }"
  (click)="toggleUpvote()"
  placement="right"
  ngbTooltip="Vote comment as meaningful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-up"></i>
    <span>{{ comment.upVoteCount }}</span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>
